module.exports = __webpack_public_path__ + "img/ic-unsuccess.cdf6f751.svg";